import { z } from "zod";
import { useForm, UseFormReturn } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { TrainingVersionFormData } from "../../trainingVersion/entities/TrainingVersion";
import { idValidation, titleValidation } from "../../../utils/validation";
import { TranslationFunction } from "../../../utils/utils";

export const useTrainingVersionFormValidation = (
  data: TrainingVersionFormData | null,
  t: TranslationFunction
): UseFormReturn<TrainingVersionFormData> => {
  const schema = z.object({
    trainingId: idValidation(),
    title: titleValidation(t),
    description: z.union([z.string(), z.null()]).optional(),
    rank: z.number().optional(),
    isAvailable: z.boolean(),
    topicIds: z.array(z.string()),
    relatedTopicIds: z.array(z.string()),
  });

  const form = useForm<TrainingVersionFormData>({
    resolver: zodResolver(schema),
    defaultValues: data ?? {},
  });

  useEffect(() => {
    form.reset({ ...(data ?? {}) });
  }, [data, form]);

  return form;
};
